const $inject = ['$scope', '$routeParams', '$filter','dataService', 'settingsService'];

const lbaTagSelectCtrl = function ($scope, $routeParams, $filter, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  const dataLookUpDataSource = dataService.spiltDataAt(vm.settings.dataSource, $routeParams);
  const tags  = _.get(dataService.data.activeItem, dataLookUpDataSource);  

  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshTags = refreshTags;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshTags(userSearch) {
    vm.tags = $filter('filter')(tags, userSearch, false);
  };

};

lbaTagSelectCtrl.$inject = $inject;

export default lbaTagSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTagSelect/lbaTagSelectCtrl.js